import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import {routes} from './routes';

require('@/assets/css/app.css')
Vue.use(VueRouter)
Vue.config.productionTip = false

const router = new VueRouter ({
  routes,
  linkExactActiveClass: "active",
  mode: 'history',
});

new Vue({
  vuetify,
  render: h => h(App),
  router
}).$mount('#app')
